import bank from './bank';

export default {
  bank,
};
